import {Component, Input, OnInit} from 'ng-metadata/core';
import {MoreLikeThisItemInfoService} from './moreLikeThisItemInfo.service';
import {ItemInfo} from "../../virtualBrowse/virtualBrowseItemInfo/virtualBrowseItemInfo.service";

const get = require('lodash/get');

@Component({
    selector: 'prm-more-like-this-item-info',
    templateUrl: 'components/search/moreLikeThis/moreLikeThisItemInfo/more-like-this-item-info.html',
})

export class PrmMoreLikeThisItemInfo implements OnInit{
    @Input() private moreLikeThisItem: any;
    @Input() private moreInTheSameCourseItem: any;
    private itemInfo: ItemInfo;
    constructor(private moreLikeThisItemInfoService: MoreLikeThisItemInfoService) {
    }

    ngOnInit() {
    }

    private courseItemTitle() {
        let value = get(this.moreInTheSameCourseItem, 'pnx.display.title[0]');
        return value && this.moreLikeThisItemInfoService.getTextFromVal(value);
    }
    
    private courseItemVerTitle() {
        let value = get(this.moreInTheSameCourseItem, 'pnx.display.vertitle[0]');
        return value && this.moreLikeThisItemInfoService.getTextFromVal(value);
    }

    private courseItemCreator() {
        let value = get(this.moreInTheSameCourseItem, 'pnx.display.creator[0]');
        return value && this.moreLikeThisItemInfoService.getTextFromVal(value);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThisItemInfo/moreLikeThisItemInfo.directive.ts